export default __webpack_public_path__ + "static/media/sne.21c25de5.png";